import Joi from 'joi';

const courseForum = {
	create: {
		title: Joi.string().min(2).required(),
		description: Joi.string().min(7).required()
	},
	thread: {
		body: Joi.string().min(2).required()
	}
};

export default courseForum;

